const uploadImage = async (image) => {
    // Get environment variables
    const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
    const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

    // Debug: Log to verify env variables are loaded (remove in production)
    console.log('Environment Check:', {
        cloudName: cloudName ? '✓ Loaded' : '✗ Missing',
        uploadPreset: uploadPreset ? '✓ Loaded' : '✗ Missing'
    });

    // Validate environment variables
    if (!cloudName || !uploadPreset) {
        console.error('Missing Cloudinary configuration!');
        console.error('Cloud Name:', cloudName);
        console.error('Upload Preset:', uploadPreset);
        throw new Error(
            'Cloudinary configuration is missing. Please check your .env file and restart your development server.'
        );
    }

    const url = `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`;

    try {
        const formData = new FormData();
        formData.append('file', image);
        formData.append('upload_preset', uploadPreset);

        console.log('Uploading to Cloudinary...');

        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });

        const data = await response.json();

        if (!response.ok) {
            console.error('Cloudinary upload error:', data);
            throw new Error(
                data.error?.message || `Upload failed: ${response.status} ${response.statusText}`
            );
        }

        console.log('Upload successful!');
        return data;
        
    } catch (error) {
        console.error('Error uploading image:', error);
        throw error;
    }
};

export default uploadImage;